import { tr } from "../../i18n";
import { useEffect, useState } from "react";
import { Eye, Download } from "lucide-react";
import { api } from "../../auth/AuthContext";
import { Badge, EmptyState, fmtDate, fileUrl } from "../../components/portal";
export default function Certificates() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/client/certificates").then(r => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return <div className="mx-auto max-w-5xl" data-testid="client-certificates">
      <h1 className="text-2xl font-semibold tracking-tight text-esaia-ink sm:text-3xl">{tr("My Certificates")}</h1>
      <p className="mt-1 text-sm text-esaia-muted">{tr("Your complete ESAIA certification history. Expired certificates remain visible for reference.")}{" "}</p>

      <div className="mt-8">
        {items === null ? <p className="text-sm text-esaia-subtle">{tr("Loading...")}</p> : items.length === 0 ? <EmptyState message={tr("No certificates have been uploaded yet.")} /> : <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {items.map(c => <div key={c.id} className="border border-esaia-line bg-white p-7" data-testid={`certificate-card-${c.certificate_number}`}>
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-sm font-semibold text-esaia-ink">{c.service_label || c.certificate_type}</p>
                    <p className="mt-1.5 font-mono text-xs text-esaia-subtle">{tr("Certificate:")}{" "}{c.certificate_number}</p>
                  </div>
                  <Badge tone={c.effective_status === "ACTIVE" ? "green" : "red"} testid={`cert-status-${c.certificate_number}`}>
                    {tr(c.effective_status)}
                  </Badge>
                </div>
                <p className="mt-4 border-t border-esaia-line pt-4 text-sm text-esaia-muted">
                  {fmtDate(c.start_date)} — {fmtDate(c.expiry_date)}
                </p>
                <div className="mt-5 flex gap-2">
                  <a href={fileUrl("certificates", c.id, true)} target="_blank" rel="noreferrer" data-testid={`cert-view-${c.certificate_number}`} className="inline-flex flex-1 items-center justify-center gap-1.5 border border-esaia-blue/40 px-3.5 py-2.5 text-xs font-semibold text-esaia-blue transition-colors hover:bg-esaia-blue hover:text-white">
                    <Eye size={14} />{" "}{tr("View Certificate")}{" "}</a>
                  <a href={fileUrl("certificates", c.id)} data-testid={`cert-download-${c.certificate_number}`} className="inline-flex flex-1 items-center justify-center gap-1.5 bg-esaia-blue px-3.5 py-2.5 text-xs font-semibold text-white transition-colors hover:bg-esaia-dark">
                    <Download size={14} />{" "}{tr("Download PDF")}{" "}</a>
                </div>
              </div>)}
          </div>}
      </div>
    </div>;
}
